/**
 * Map name for mutations
 * @types {string}
 */

export const SET_AVAILABLE_BANNERS = "LANDING_PAGE/SET_AVAILABLE_BANNERS";
export const SET_SELECTED_BANNERS = "LANDING_PAGE/SET_SELECTED_BANNERS";
export const SET_LP_PRODUCTS = "LANDING_PAGE/SET_LP_PRODUCTS";
